<ion-grid class="ai-configuration">

    <ion-row>

        <ion-col size="12" class="ion-no-padding">

            <ion-card class="ion-no-margin full">

                <ion-card-header>
                    <ion-card-title i18n=":@@configurations_ai.title-configuration">Configuração de AI</ion-card-title>

                    <ion-buttons>

                        <ng-container *ngIf="!IsEditing">
                            <ion-button fill="solid" color="medium" title="Editar" (click)="OnEdit($event)"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                            </ion-button>
                        </ng-container>

                        <ng-container *ngIf="IsEditing">
                            <ion-button fill="solid" color="medium" title="Cancelar" (click)="OnCancelEdit($event)"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                            </ion-button>

                            <ion-button fill="solid" color="primary" title="Guardar" (click)="OnSave($event)"
                                [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT">
                                <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                            </ion-button>
                        </ng-container>

                    </ion-buttons>

                </ion-card-header>

                <ion-card-content>

                    <form [formGroup]="Form">

                        <ion-row>

                            <ion-col size="12" sizeMd="6">

                                <ion-radio-group formControlName="IsActive">

                                    <ion-item [disabled]="Form.get('IsActive').disabled">
                                        <ion-label position="stacked" i18n=":@@configurations_ai.state" required>Estado
                                        </ion-label>
                                        <ion-grid>
                                            <ion-row>
                                                <ion-col>
                                                    <ion-item lines="none" [disabled]="Form.get('IsActive').disabled">
                                                        <ion-label i18n=":@@configurations_ai.active">Ativo</ion-label>
                                                        <ion-radio slot="start" [value]="true"></ion-radio>
                                                    </ion-item>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-item lines="none" [disabled]="Form.get('IsActive').disabled">
                                                        <ion-label i18n=":@@configurations_ai.disabled">Desativo
                                                        </ion-label>
                                                        <ion-radio slot="start" [value]="false"></ion-radio>
                                                    </ion-item>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>
                                    </ion-item>

                                </ion-radio-group>
                            </ion-col>

                            <ion-col size="12" sizeMd="6">
                                <ion-item class="full" lines="full">
                                    <ion-label position="stacked" i18n=":@@configurations_ai.api-key" required>Chave de
                                        API
                                    </ion-label>
                                    <password-toggle>
                                        <ion-input type="password" formControlName="ApiKey" autocomplete="off"
                                            [placeholder]="Data?.HasApiKey ? (Data?.ApiKeyMask || '••••••••') : 'Introduza a chave de API'">
                                        </ion-input>
                                    </password-toggle>
                                </ion-item>
                                <ion-note *ngIf="Data?.HasApiKey" class="hint"
                                    i18n=":@@configurations_ai.api-key-hint">A chave guardada não é apresentada. Preencha
                                    apenas para a substituir.</ion-note>
                            </ion-col>

                        </ion-row>

                        <ion-row>

                            <ion-col size="12" sizeMd="6">
                                <ion-item class="full" lines="full">
                                    <ion-label position="stacked" i18n=":@@configurations_ai.currency" required>Moeda
                                    </ion-label>
                                    <ion-select formControlName="IdCurrency" interface="popover"
                                        [disabled]="Form.get('IdCurrency').disabled">
                                        <ion-select-option [value]="EnumAICurrency.EUR">EUR (€)</ion-select-option>
                                        <ion-select-option [value]="EnumAICurrency.USD">USD ($)</ion-select-option>
                                    </ion-select>
                                </ion-item>
                            </ion-col>

                            <ion-col size="12" sizeMd="6">
                                <ion-item class="full" lines="full">
                                    <ion-label position="stacked" i18n=":@@configurations_ai.cost-limit" required>Limite
                                        de custo mensal
                                    </ion-label>
                                    <ion-input type="number" min="0" step="0.01" formControlName="CostLimitMonth">
                                    </ion-input>
                                </ion-item>
                                <ion-note class="hint" i18n=":@@configurations_ai.cost-limit-hint">Ao atingir o limite,
                                    os pedidos de AI deixam de ser executados até ao mês seguinte.</ion-note>
                            </ion-col>

                        </ion-row>

                    </form>

                    <ion-row *ngIf="Data?.UpdateDate">
                        <ion-col size="12">
                            <ion-note class="hint">
                                <ng-container i18n=":@@configurations_ai.last-update">Última alteração</ng-container>:
                                <date-tooltip [date]="Data?.UpdateDate"></date-tooltip>
                            </ion-note>
                        </ion-col>
                    </ion-row>

                </ion-card-content>
            </ion-card>

        </ion-col>

    </ion-row>

    <ion-row>

        <ion-col size="12" class="ion-no-padding">

            <ion-card class="ion-no-margin ion-margin-top full">

                <ion-card-header>
                    <ion-card-title i18n=":@@configurations_ai.title-consumption">Consumo mensal</ion-card-title>

                    <ion-item class="year-select" lines="none">
                        <ion-select [value]="Year" interface="popover" (ionChange)="OnChangeYear($event)">
                            <ion-select-option *ngFor="let item of Years" [value]="item">{{ item }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>

                </ion-card-header>

                <ion-card-content>

                    <ion-row class="tiles">

                        <ion-col size="6" sizeMd="3">
                            <stat-tile [value]="FormatCost(CurrentMonthCost)" [variant]="CostLimitVariant"
                                label="Custo do mês corrente" i18n-label=":@@configurations_ai.tile-current-cost">
                            </stat-tile>
                        </ion-col>

                        <ion-col size="6" sizeMd="3">
                            <stat-tile [value]="CostLimit > 0 ? FormatCost(CostLimit) : '--'"
                                label="Limite mensal" i18n-label=":@@configurations_ai.tile-limit">
                            </stat-tile>
                        </ion-col>

                        <ion-col size="6" sizeMd="3">
                            <stat-tile [value]="CostLimit > 0 ? (CostLimitUsedPercent + '%') : '--'"
                                [variant]="CostLimitVariant" label="Limite utilizado"
                                i18n-label=":@@configurations_ai.tile-limit-used">
                            </stat-tile>
                        </ion-col>

                        <ion-col size="6" sizeMd="3">
                            <stat-tile [value]="Data?.CurrentMonthRequests || 0" label="Pedidos do mês corrente"
                                i18n-label=":@@configurations_ai.tile-current-requests">
                            </stat-tile>
                        </ion-col>

                    </ion-row>

                    <ion-row *ngIf="Consumption?.length > 0">
                        <ion-col size="12">
                            <div class="chart-box">
                                <bar-chart *ngIf="Chart" [data]="Chart" height="240"></bar-chart>
                            </div>
                        </ion-col>
                    </ion-row>

                    <ion-grid class="table ion-no-padding">

                        <ion-row class="table-header">
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-month">Mês</ion-col>
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-requests">Pedidos
                            </ion-col>
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-tokens-in">Tokens
                                entrada</ion-col>
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-tokens-out">Tokens saída
                            </ion-col>
                            <ion-col class="flex-align-center" i18n=":@@configurations_ai.table-cost">Custo</ion-col>
                            <ion-col class="flex-align-center col-status-icon-2"
                                i18n=":@@configurations_ai.table-limit-reached">Limite</ion-col>
                        </ion-row>

                        <ion-row *ngFor="let item of Consumption" style="display: block;">
                            <ion-item class="ion-no-margin">

                                <ion-grid class="ion-no-margin ion-no-padding">

                                    <ion-row class="table-body">

                                        <ion-col class="flex-align-center">{{ MonthLabel(item) }}</ion-col>
                                        <ion-col class="flex-align-center">{{ item?.Requests || 0 }}</ion-col>
                                        <ion-col class="flex-align-center">{{ item?.InputTokens || 0 }}</ion-col>
                                        <ion-col class="flex-align-center">{{ item?.OutputTokens || 0 }}</ion-col>
                                        <ion-col class="flex-align-center">{{ FormatCost(item?.Cost, item?.IdCurrency)
                                            }}</ion-col>
                                        <ion-col class="flex-align-center col-status-icon-2">
                                            <ion-badge *ngIf="item?.LimitReached" color="danger"
                                                i18n=":@@configurations_ai.limit-reached">Atingido</ion-badge>
                                        </ion-col>

                                    </ion-row>

                                </ion-grid>

                            </ion-item>
                        </ion-row>

                        <ion-row *ngIf="!Consumption || Consumption?.length == 0">
                            <ion-col>
                                <no-items description="sem consumo registado"
                                    i18n-description=":@@configurations_ai.no-consumption"></no-items>
                            </ion-col>
                        </ion-row>

                    </ion-grid>

                </ion-card-content>
            </ion-card>

        </ion-col>

    </ion-row>

</ion-grid>
